const primaryColor = "";
const secondaryColor = "";
const titleFont = "riesling";
const titleColor = "rgba(223, 190, 106, 0.7)";

export { primaryColor, secondaryColor, titleColor, titleFont };
